import * as React from 'react';
import { clampValue } from '@/lib/numeric';

export interface FreeValueProps {
  value?: number;
  defaultValue?: number;
  onValueChange?: (value: number) => void;
  onValueCommit?: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  resetValue?: number;
  precision?: number;
  label?: string;
  disabled?: boolean;
}

export function useFreeValue(props: FreeValueProps) {
  const { min = 0, max = 1, step = (max - min) / 100 || 1 } = props;
  const [local, setLocal] = React.useState(props.defaultValue ?? props.value ?? min);
  const value = clampValue(props.value ?? local, min, max, step);
  const current = React.useRef(value);
  React.useEffect(() => { current.current = value; }, [value]);
  function change(next: number, commit = false) {
    if (props.disabled) return;
    next = clampValue(next, min, max, step);
    current.current = next;
    if (props.value === undefined) setLocal(next);
    props.onValueChange?.(next);
    if (commit) props.onValueCommit?.(next);
  }
  return { value, current, change, min, max, step, commit: () => { if (!props.disabled) props.onValueCommit?.(current.current); }, reset: () => change(props.resetValue ?? (min + max) / 2, true) };
}
